import { render, staticRenderFns } from "./QrisOrder.vue?vue&type=template&id=36fac172&lang=html"
import script from "./QrisOrder.vue?vue&type=script&lang=js"
export * from "./QrisOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports